export default __webpack_public_path__ + "353f4580405b5a20954f036f7cdacd85.png";